import * as Actions from "../action/claim";

const initialState = {
  claimData: [],
  piClaimData: {},
  loading: true,
  error: null,

  // 🔥 NEW FOR DASHBOARD STATS
  claimsByStatus: [],
  claimsByManagementType: [],
};

const claimReducer = function (state = initialState, action) {
  switch (action.type) {

    case Actions.GET_CLAIM: {
      return {
        ...state,
        claimData: action.payload,
        loading: false,
      };
    }

    case Actions.GET_CLAIM_COUNT_BY_STATUS: {
      return {
        ...state,
        claimsByStatus: action.payload,
        loading: false,
      };
    }

    case Actions.GET_CLAIM_COUNT_BY_MANAGEMENT_TYPE: {
      return {
        ...state,
        claimsByManagementType: action.payload,
        loading: false,
      };
    }

    case Actions.CREATE_CLAIM: {
      return { ...state, claimData: action.payload };
    }

    case Actions.DELETE_CLAIM: {
      return {
        ...state,
        claimData: state.claimData.filter(
          (item) => item._id !== action.payload
        ),
      };
    }
    case Actions.FILTER_CLAIM_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }

    case Actions.FILTER_CLAIM_SUCCESS: {
      return {
        ...state,
        loading: false,
        claimData: action.payload.data,   // <-- filtered rows
        total: action.payload.total,      // <-- pagination
        page: action.payload.page,
        limit: action.payload.limit,
      };
    }

    case Actions.CLEAR_CLAIMS:
      return {
        ...state,
        claimData: [],
      };

    case Actions.FETCH_PI_CLAIM_DATA_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }

    case Actions.FETCH_PI_CLAIM_DATA_SUCCESS: {
      return {
        ...state,
        loading: false,
        piClaimData: action.payload,
      };
    }

    case Actions.UPDATE_CLAIM_SUCCESS: {
      return {
        ...state,
        loading: false,
        claimData: state.claimData.map((claim) =>
          claim._id === action.payload._id ? action.payload : claim
        ),
      };
    }

    // fusion du seul statut : le document renvoyé par UpdateStatus n'a pas les champs peuplés de FilterClaim
    case Actions.UPDATE_CLAIM_STATUS_SUCCESS: {
      return {
        ...state,
        claimData: Array.isArray(state.claimData)
          ? state.claimData.map((claim) =>
              claim.claimNumber === action.payload.claimNumber
                ? { ...claim, status: action.payload.status }
                : claim
            )
          : state.claimData,
      };
    }

    case Actions.FILTER_CLAIM_FAILURE:
    case Actions.UPDATE_CLAIM_FAILURE:
    case Actions.FETCH_PI_CLAIM_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default claimReducer;
